module.exports = __webpack_public_path__ + "static/media/bvlgari-aqua-pour-homme-big.29116bbb.png";